// topスライド
$(window).on('load', function() {
    var $slide_list = $('.slide_list');

    $slide_list.slick({
        arrows: false, // 前・次のボタンを表示しない
        dots: true, // ドットナビゲーションを表示する
        appendDots: $('.dots-4'), // ドットナビゲーションの生成位置を変更
        fade: true, // スライド切り替えをフェード
        autoplay: true, //自動再生させない
        slidesToShow: 1, // 表示させるスライド数
    });

    $slide_list.imagesLoaded(function() {
        $slide_list.find('li').each(function () {
            $(this).removeClass('is-loading');
        });
    });
});

// products　スライダー
// $(window).on('load', function() {
//     var $products_slide = $('#products_slide'),
//         slides_len      = $products_slide.find('li').length,
//         dots;
    
//     if(slides_len < 4) dots = false;
//     else               dots = true;
    
//     $products_slide.slick({
//         arrows: false,
//         dots: dots,
//         dotsClass: 'recommend-dots',
//         appendDots: $('.products_dots'),
//         autoplay: true,
//         slidesToShow: 3,
//         slidesToScroll: 1,
//     });
//     $products_slide.imagesLoaded(function() {
//         $products_slide.find('li img').each(function () {
//             $(this).removeClass('is-loading');
//         });
//     });
// });

// products詳細ページ　スライダー
$(window).on('load', function() {
    var $products_thumb_slide = $('#products_detail_thumb_slide'),
        $productsDetail_slide = $('#products_detail_slide'),
        slideNum              = $products_thumb_slide.find('li').length,
        slidesToShow;
    
    if(slideNum > 3)       slidesToShow = 3;
    else if(slideNum == 3) slidesToShow = 2;
    else                   slidesToShow = slideNum;

    $products_thumb_slide.slick({
        arrows: false, // 前・次のボタンを表示しない
        dots: false, // ドットナビゲーションを表示する
        vertical: true,
        autoplay: false, //自動再生させない
        slidesToShow: slideNum, // 表示させるスライド数
    });
    $productsDetail_slide.slick({
        arrows: false, // 前・次のボタンを表示しない
        focusOnSelect: true,
        vertical: true,
        dots: true, // ドットナビゲーションを表示する
        appendDots: $('.products_detail_dots'), // ドットナビゲーションの生成位置を変更
        dotsClass: 'products-dots',
        autoplay: false, //自動再生させない
        slidesToShow: slidesToShow, // 表示させるスライド数
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 1000,
            settings: {
                vertical: false,
                slidesToShow: 1,
            }
        }]
    });
    $('#products_detail_thumb_slide li').click(function () {
        var i = $('#products_detail_thumb_slide li').index(this);
        // console.log(i);
        $productsDetail_slide.slick('slickGoTo', i);
    });

    $(window).on('resize', function() {
        if($(window).width() > 1000 && slidesToShow >= 3) {
            var slideHeight       = $productsDetail_slide.find('.slick-slide').outerHeight(),
                slideMarginBottom = parseInt( $productsDetail_slide.find('.slick-slide').css('margin-bottom') ),
                maxHeight         = (slideHeight + slideMarginBottom)*(slidesToShow - 1) + slideHeight/3;
            $productsDetail_slide.find('.slick-list').css('max-height', maxHeight);
        } else {
            $productsDetail_slide.find('.slick-list').css('max-height', 'initial');
        }
    });
    $(window).trigger('resize');
    
    $productsDetail_slide.imagesLoaded(function() {
        $productsDetail_slide.find('li').each(function () {
            $(this).removeClass('is-loading');
        });
    });
});



// モーダルウィンドウ
var flag = 0;
$(window).scroll(function () {
    if ($(this).scrollTop() > 300 && flag == 0 && $(this).scrollTop() < 600) {
        $('.js-modal').fadeIn();
        flag = 1;
        return false;
    }
    $('.js-modal-close').on('click', function () {
        $('.js-modal').fadeOut();
        return false;
    });
});

// サイドバー色変え
$('.side_bar').each(function() {
    $(window).on('scroll', function () {
        var off = $('.products_box').offset();
        var f_off = $('footer').offset();
        if ($(window).scrollTop() > off.top && $(window).scrollTop() < f_off.top) {
            $('.side_bar ul').addClass('active');
        } else if ($(window).scrollTop() > f_off.top) {
            $('.side_bar ul').removeClass('active');
        } else {
            $('.side_bar ul').removeClass('active');
        }
    });
});

$('#hamburg_menu').click(function () {
    $('.side_bar ul').removeClass('active');
});
$('#hamburg_inner_menu').click(function () {
    $('.side_bar ul').addClass('active');
});
$('#search_btn').click(function () {
    $('.side_bar ul').removeClass('active');
});
$('#search_inner_menu').click(function () {
    $('.side_bar ul').addClass('active');
});

// ハンバーガーメニュー開閉
$('#hamburg_menu').click(function () {
    $('#hamburg_inner').fadeIn(500);
    $('#hamburg_inner .menu').fadeIn(600);
    $('.side_bar').fadeOut(500);
});
$('#hamburg_inner_menu').click(function () {
    $('#hamburg_inner').fadeOut();
    $('#hamburg_inner .menu').hide();
    $('.side_bar').fadeIn();
});
$('#hamburg_inner .menu #search_btn').click(function () {
    $('#hamburg_inner').fadeOut();
    $('#hamburg_inner .menu').hide();
    $('#search_inner').fadeIn(500);
    $('#search_inner_menu').fadeIn(600);
    // 検索ボックスアニメーション
    $('#search_inner .search_form input[id="sbox"]').animate({
            opacity: 1
        },
        2000,
    );
    $('#search_inner .search_form input[id="sbtn"]').animate({
            opacity: 1,
        },
        1000,
    );
    $('#search_inner .search_form').addClass('active');
});

// サーチメニュー開閉
$('#search_btn').click(function () {
    $('#search_inner').fadeIn(500);
    $('#search_inner_menu').fadeIn(600);
    // 検索ボックスアニメーション
    $('#search_inner .search_form input[id="sbox"]').animate({
            opacity: 1
        },
        2000,
    );
    $('#search_inner .search_form input[id="sbtn"]').animate({
            opacity: 1,
        },
        1000,
    );
    $('#search_inner .search_form').addClass('active');
    $('.side_bar').fadeOut(500);
});
$('#search_inner_menu').click(function () {
    $('#search_inner').fadeOut();
    $('#search_inner_menu').hide();
    $('#search_inner .search_form input[id="sbox"]').animate({
            opacity: 0
        },
        500,
    );
    $('#search_inner .search_form input[id="sbtn"]').animate({
            opacity: 0,
        },
        500,
    );
    $('#search_inner .search_form').removeClass('active');
    $('.side_bar').fadeIn();
});

// 言語ボタン
$('.icon_menu ul.lang_list li.list_btn').click(function () {
    $('.icon_menu ul.lang_list li.list_btn').prev('li').toggleClass('active');
    $('.icon_menu ul.lang_list li.list_btn').toggleClass('active');
});
$('#hamburg_inner ul.lang_list li.list_btn').click(function () {
    $('#hamburg_inner menu ul.lang_list li.list_btn').prev('li').toggleClass('active');
    $('#hamburg_inner menu ul.lang_list li.list_btn').toggleClass('active');
    console.log('1');
});

// 商品アニメーション
var i = 0;
var delay = 1000;
$(function () {
    $(window).scroll(function () {
        $('.products_box').each(function () {
            var position = $(this).offset().top;
            var scroll = $(window).scrollTop();
            var windowHeight = $(window).height();
            if (scroll > position - 800) {
                for (i = 0; i <= $('.products_box .box_inner ul li').length; i++) {
                    $('.products_box .box_inner ul li:nth-child(' + i + ')').delay(delay).queue(function () {
                        $(this).addClass('active').dequeue();
                    });
                    delay += 150;
                }
            }
        });
    });
});

//about　アニメーション
var id = $('.contents').attr('id');
if (id == 'sv-home') {
    $(window).scroll(function () {
        if ($(this).scrollTop() > $('.products_box .box_inner .btn').offset().top) {
            $('.about_box .box_inner>.fig').addClass('active');
        }
        if ($(this).scrollTop() > $('.about_box').offset().top) {
            $('.about_box .box_inner>.fig_lbls').addClass('active');
        }
        if ($(this).scrollTop() > $('.about_box .box_inner .btn').offset().top) {
            $('.about_box .box_inner .detail_box.interior').addClass('active');
        }
        if ($(this).scrollTop() > $('.about_box .box_inner .detail_box.interior dl').offset().top) {
            $('.about_box .box_inner .detail_box.pot').addClass('active');
        }
        if ($(this).scrollTop() > $('.about_box .box_inner .detail_box.pot dl').offset().top) {
            $('.about_box .box_inner .detail_box.art').addClass('active');
        }
    });
}
if (id == "sv-about") {
    $(window).scroll(function () {
        if ($(this).scrollTop() > $('.products_box .box_inner').offset().top) {
            $('.products_box .box_inner .about p').addClass('active');
        }
        if ($(this).scrollTop() > $('.products_box .box_inner p.active').offset().top + 300) {
            $('.products_box .box_inner .fig.concierge').addClass('active');
        }
        if ($(this).scrollTop() > $('.products_box .box_inner .concierge h2').offset().top) {
            $('.products_box .box_inner .fig.concierge2').addClass('active');
        }
        if ($(this).scrollTop() > $('.products_box .box_inner .fig.concierge').offset().top + 200) {
            $('.products_box .box_inner .concierge p:nth-child(3)').addClass('active');
        }
        if ($(this).scrollTop() > $('.products_box .box_inner .fig.concierge2').offset().top + 200) {
            $('.products_box .box_inner .concierge p:nth-child(5)').addClass('active');
        }
        if ($(this).scrollTop() > $('.products_box .box_inner .fig.concierge2').offset().top + 200) {
            $('.products_box .box_inner .how_to_reserve').addClass('active');
        }
        if ($(this).scrollTop() > $('.products_box .box_inner .how_to_reserve').offset().top + 200) {
            $('.products_box .box_inner dl.access').addClass('active');
        }
    });
}

// BLOG
$(window).on('load', function() {
    $('.blog_box .box_inner ul').each(function() {
        var $blog_ul   = $(this),
            delay_blog = 1000,
            windowHeight = $(window).height(),
            position = $blog_ul.offset().top,
            len = $blog_ul.find('li').length;
        
        $(window).on('scroll', function() {
            var scroll = $(window).scrollTop();
            
            if(scroll > position - windowHeight*2/3) {
                for(var i=0; i<=len; i++) {
                    $blog_ul.find('li:nth-child(' + i + ')').delay(delay_blog).queue(function () {
                        $(this).addClass('active').dequeue();
                    });
                    delay_blog += 150;
                }
            }
        });
    });
});

// input 希望日時
// $('.sv-cart .form_box .form_inner form table td ul li:nth-child(1) span.title').click(function () {
//     if ($(this).parents('li').hasClass('active')) {
//         $('.sv-cart .form_box .form_inner form table td ul li:nth-child(1) input').stop(true, false).slideToggle();
//         $(this).parents('li').removeClass('active');
//     } else {
//         $('.sv-cart .form_box .form_inner form table td ul li:nth-child(1) input').stop(true, false).slideToggle();
//         $(this).parents('li').addClass('active');
//     }
// });
$('.sv-cart .form_box .form_inner form table td ul li:nth-child(2) span.title').click(function () {
    if ($(this).parents('li').hasClass('active')) {
        $('.sv-cart .form_box .form_inner form table td ul li:nth-child(2) input').stop(true, false).slideToggle();
        $(this).parents('li').removeClass('active');
    } else {
        $('.sv-cart .form_box .form_inner form table td ul li:nth-child(2) input').stop(true, false).slideToggle();
        $(this).parents('li').addClass('active');
    }
});
$('.sv-cart .form_box .form_inner form table td ul li:nth-child(3) span.title').click(function () {
    if ($(this).parents('li').hasClass('active')) {
        $('.sv-cart .form_box .form_inner form table td ul li:nth-child(3) input').stop(true, false).slideToggle();
        $(this).parents('li').removeClass('active');
    } else {
        $('.sv-cart .form_box .form_inner form table td ul li:nth-child(3) input').stop(true, false).slideToggle();
        $(this).parents('li').addClass('active');
    }
});

// カートページ　モーダル
$(document).ready(function () {
    $('.cart_popup').magnificPopup({
        type: 'ajax'
    });
});
// カートページ　商品個数追加
$('.products_box .box_inner ul.cart_list li ul.count_list li:last-child').click(function () {
    var i = $(this).prev('li').html();
    i++;
    $(this).prev('li').html(i);
    console.log(i);
});
$('.products_box .box_inner ul.cart_list li ul.count_list li:first-child').click(function () {
    var i = $(this).next('li').html();
    i--;
    $(this).next('li').html(i);
    console.log(i);
});

// ALL PRODUCTS　並べ替えメニュー
$('.products_box .box_inner .products_menu>ul').click(function () {
    $('.products_box .box_inner .products_menu>ul li .position').toggleClass('active');
    $('.products_box .box_inner .products_menu>ul').toggleClass('active');

});

// ALL PRODUCTS 商品アニメーション
var i_products = 0;
var delay_products = 500;
$(function () {
    $(window).on('load', function () {
        for (i_products = 0; i_products <= $('.products_box .box_inner .products_list .products_inner ul li').length; i_products++) {
            $('.products_box .box_inner .products_list .products_inner ul li:nth-child(' + i_products + ')').delay(delay_products).queue(function () {
                $(this).addClass('active').dequeue();
            });
            delay_products += 150;
        }
    });
});



/*
 * ヘッダー関連
 * 2022.12 inc.村上 追加
 */
// スティッキー動作
$(window).on('load', function() {
    $('.sv-header').each(function() {
        var $window = $(window),
            $header = $(this),
            headerOffsetTop = $header.offset().top;

        $window.on('scroll', function() {
            if($window.scrollTop() > headerOffsetTop) {
                $header.addClass('sticky');
            } else {
                $header.removeClass('sticky');
            }
        });
        $window.trigger('scroll');
    });
});

// index 以外のページ上部に，ヘッダー分の padding を設ける
$(function(){
    $(window).on('resize', function() {
        var $contents     = $('main#page-content .contents'),
            $header       = $contents.find('header'),
            headerHeight  = $header.outerHeight(),
            $mainSection  = $contents.find('main.sv-main');
        $contents.not('#sv-home').each(function() {
            $mainSection.css('padding-top', headerHeight);
        });
    });
    $(window).trigger('resize');
});


/*
 * Collection ページのグリッドレイアウト
 * 2023.01 inc.村上 追加
 */
$(function(){
    var minWidth = 450;
    var $container = $('.sv-collection #collection-grid');

    if($(window).width() <= minWidth) {
        $container.masonry('destroy');
    } else {
        var $grid = $container.each(function() {
            var $container = $(this);
            
            // $container.find('li.grid-item').eq(0).addClass('grid-item-big');
            // $container.find('li.grid-item').eq(13).addClass('grid-item-big');
            $container.masonry({
                itemSelector: '.grid-item',
                columnWidth: '.grid-sizer',
                gutter: '.gutter-sizer',
                percentPosition: true
            });
        });
        $grid.imagesLoaded().progress(function() {
            $grid.masonry('layout');
        });
    }
    $(window).trigger('resize');
});


/*
 * JSによる Collectionページのページネーション HTML/CSS 編集
 * 2023.01 inc.村上 追加
 */
$(function(){
    $('#page-list').each(function() {
        var $spanItem = $(this).find('span'),
            len       = $spanItem.length,
            percent   = 100/len;

        $spanItem.each(function() {
            $(this).css('width', percent+'%');
        });

        $(this).find('.prev').each(function() {
            var $prev = $(this),
                prevHref,
                prevHTML;
            prevHref = $prev.find('a').attr('href');
            prevHTML = '<a href="' + prevHref + '"><i class="fa-solid fa-chevron-left"></i></a>';
            $prev.html(prevHTML);
            $prev.show();
        });
        $(this).find('.next').each(function() {
            var $next = $(this),
                nextHref,
                nextHTML;
            nextHref = $next.find('a').attr('href');
            nextHTML = '<a href="' + nextHref + '"><i class="fa-solid fa-chevron-right"></i></a>';
            $next.html(nextHTML);
            $next.show();
        });
    });
});


/*
 * カートページ コンシェルジュフォーム
 * 2023.01 inc.村上 追加
 */
$(function(){
    // フォームの開閉
    $('#form-box').each(function() {
        var $form = $(this),
            $conciergeBtn = $('#concierge-btn'),
            $closeBtn     = $form.find('.modal-close');

        function bodyFixedOn() {  //スクロールを固定
            scrollTop = $(window).scrollTop();
            $('body').css({
                position: 'fixed',
                top: -scrollTop
            });
        }
        function bodyFixedOff() {  //スクロールの固定を解除
            $('body').css({
                position: '',
                top: ''
            });
        }

        $conciergeBtn.on('click', function() {
            if( $('#concierge-check').length ) {
                if( $('#concierge-check').is(':checked') ) {
                    bodyFixedOn();
                    $form.fadeIn();
                    return true;
                } else {
                    alert('利用規約に同意してください');
                    return false;
                }
            } else {
                bodyFixedOn();
                $form.fadeIn();
            }
        });
        $closeBtn.on('click', function() {
            bodyFixedOff();
            $form.fadeOut();
        });
    });


    // セッションの管理
    var $formContent = $('#form-box');
    var $products = $formContent.find('input[name="contact[予約商品]"]'),
        $nums     = $formContent.find('input[name="contact[個数]"]'),
        $allNums  = $formContent.find('input[name="contact[合計点数]"]'),
        $name  = $formContent.find('input[name="contact[お名前]"]'),
        $tel   = $formContent.find('input[name="contact[電話番号]"]'),
        $email = $formContent.find('input[name="contact[email]"]'),
        $date1 = $formContent.find('input[name="contact[第1希望]"]'),
        $date2 = $formContent.find('input[name="contact[第2希望]"]'),
        $date3 = $formContent.find('input[name="contact[第3希望]"]'),
        $note  = $formContent.find('textarea[name="contact[備考]"]');
    const keyProducts  = 'products',
          keyNums      = 'num',
          keyAllNums   = 'allNums',
          keyName  = 'name',
          keyTel   = 'tel',
          keyEmail = 'email',
          keyDate  = 'date',
          keyNote  = 'note';
    var valProducts = [], valNums = [], valAllNums;
    var valName, valTel, valEmail, valDate = [], valNote;
    
    function removeItems() {
        window.sessionStorage.removeItem([keyProducts]);
        window.sessionStorage.removeItem([keyNums]);
        window.sessionStorage.removeItem([keyAllNums]);
        window.sessionStorage.removeItem([keyName]);
        window.sessionStorage.removeItem([keyTel]);
        window.sessionStorage.removeItem([keyEmail]);
        window.sessionStorage.removeItem([keyDate]);
        window.sessionStorage.removeItem([keyNote]);
    }

    $formContent.on('submit', function(e) {
        e.preventDefault();
        for(var i=0; i<$products.length; i++) {
            valProducts.push($products.eq(i).val());
            valNums.push($nums.eq(i).val());
        }
        valAllNums = $allNums.val();
        valName  = $name.val();
        valTel   = $tel.val();
        valEmail = $email.val();
        valDate  = [$date1.val(), $date2.val(), $date3.val()];
        valNote  = $note.val();
        
        window.sessionStorage.setItem([keyProducts], [valProducts]);
        window.sessionStorage.setItem([keyNums], [valNums]);
        window.sessionStorage.setItem([keyAllNums], [valAllNums]);
        window.sessionStorage.setItem([keyName], [valName]);
        window.sessionStorage.setItem([keyTel], [valTel]);
        window.sessionStorage.setItem([keyEmail], [valEmail]);
        window.sessionStorage.setItem([keyDate], [valDate]);
        window.sessionStorage.setItem([keyNote], [valNote]);

        window.location = "https://supervintage.design/pages/confirm";
    });
    var getProducts = window.sessionStorage.getItem([keyProducts]).split(','),
        getNums     = window.sessionStorage.getItem([keyNums]).split(','),
        getAllNums  = window.sessionStorage.getItem([keyAllNums]),
        getName  = window.sessionStorage.getItem([keyName]),
        getTel   = window.sessionStorage.getItem([keyTel]),
        getEmail = window.sessionStorage.getItem([keyEmail]),
        getDate  = window.sessionStorage.getItem([keyDate]).split(','),
        getNote  = window.sessionStorage.getItem([keyNote]);

    var $confirmContent = $('#confirm'),
        $confirmForm    = $confirmContent.find('form');

    var productsHTML = '';
    for(var i=0; i<getProducts.length; i++) {
        productsHTML += '<input class="hidden" type="text" name="contact[予約商品 ' + (i+1) +']" value="' + getProducts[i] + ': ' + getNums[i] + '"></input>';
    }

    var dateHTML = '';
    for(var i=0; i<3; i++) {
        dateHTML += '<li>[第' + (i+1) + '希望]　';
        if(getDate[i] != '') {
            dateHTML += getDate[i] + ' ~</li>';
        } else {
            dateHTML += 'なし</li>';
        }
    }

    $confirmContent.find('form').prepend(productsHTML);
    $confirmContent.find('input[name="contact[合計点数]"]').val(getAllNums);

    $confirmContent.find('.name').text(getName);
    $confirmContent.find('input[name="contact[お名前]"]').val(getName);
    
    $confirmContent.find('.tel').text(getTel);
    $confirmContent.find('input[name="contact[電話番号]"]').val(getTel);

    $confirmContent.find('.email').text(getEmail);
    $confirmContent.find('input[name="contact[email]"]').val(getEmail);

    $confirmContent.find('.date').html(dateHTML);
    $confirmContent.find('input[name="contact[第1希望]"]').val(getDate[0]);
    $confirmContent.find('input[name="contact[第2希望]"]').val(getDate[1]);
    $confirmContent.find('input[name="contact[第3希望]"]').val(getDate[2]);

    $confirmContent.find('.note').text(getNote);
    $confirmContent.find('textarea[name="contact[備考]"]').val(getNote);

    $confirmForm.on('submit', function() {
        removeItems();
    });
});
